module.exports = __webpack_public_path__ + "static/media/nvidia.140a4e6b.svg";